
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Multiselect from 'vue-multiselect';
import Pagination from 'laravel-vue-pagination';

import Plants from './components/Plants.vue';
import Plant from './components/partials/Plant.vue';

Vue.component('multiselect', Multiselect);
Vue.component('pagination', Pagination);
Vue.component('plants', Plants);
Vue.component('plant-card', Plant);

new Vue({
    component: Plants
}).$mount('#app')
